import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {OnboardWizard} from '@/features/admin/onboard/OnboardWizard'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function OnboardGuard() {
	if (!useRequirePermission(Actions.ORGS_MANAGE)) return null
	return <OnboardWizard />
}

export const Route = createFileRoute('/admin/onboard')({
	component: OnboardGuard,
})
